export enum CounterSize {
  L = 'l',
  M = 'm',
  S = 's',
}
